<template>
  <div class="result-detail">
    <div class="result-filter-list">
      <div class="search">
        <a-input
          placeholder="请输入名字/编号查找"
          prefixIcon="search"
          v-model="keywords"
          size="large"
          @keyup.enter="search"
        >
          <template slot="suffix">
            <div @click.enter="search" class="search-btn">搜索</div>
          </template>
        </a-input>
      </div>
      <template v-if="matchExamDateList.length > 0">
        <div class="scro-list">
          <div
            v-for="(item, index) in matchExamDateList"
            :key="index"
            :class="['scro-item', { 'sco-active': index === dateIndex }]"
            @click="handleDateTime(item, index)"
          >
            {{ item.matchTime }}
          </div>
        </div>
      </template>
      <template v-if="matchCombatList.length > 0">
        <div class="scro-list">
          <div
            v-for="(item, index) in matchCombatList"
            :key="index"
            :class="['scro-item', { 'sco-active': index === projectIndex }]"
            @click="handleProject(item, index)"
          >
            {{ item.combatTitle }}
          </div>
        </div>
      </template>
      <template v-if="sexList.length > 0">
        <div class="scro-list">
          <div
            v-for="(item, index) in sexList"
            :key="index"
            :class="['scro-item', { 'sco-active': index === sexIndex }]"
            @click="handleSex(item, index)"
          >
            {{ item.sex == 1 ? '男' : '女' }}
          </div>
        </div>
      </template>
      <template v-if="examTypeList.length > 0">
        <div class="scro-list">
          <div
            v-for="(item, index) in examTypeList"
            :key="index"
            :class="['scro-item', { 'sco-active': index === examTypeIndex }]"
            @click="handleExam(item, index)"
          >
            {{ item.examName }}
          </div>
        </div>
      </template>
    </div>
    <div class="collapse">
      <a-collapse expand-icon-position="right" :bordered="false">
        <template #expandIcon="props">
          <div class="collapse-reduce" v-if="props.isActive">
            <a-icon type="minus" style="font-size: 12px;color: #fff;" />
          </div>
          <div class="collapse-add" v-else>
            <a-icon type="plus" style="font-size: 12px;color: #fff;" />
          </div>
        </template>

        <a-collapse-panel :key="item.id" :style="customStyle" v-for="(item, index) in dataList">
          <template #header="props">
            <div
              class="match-title"
              :style="{
                backgroundColor: props.isActive ? '#31383f' : '#fff',
                color: props.isActive ? ' #fff' : '#31383f',
              }"
            >
              <div class="left">
                {{ item.groupName }}
              </div>
            </div>
          </template>
          <div class="record">
            <div class=" record-item record-title">
              <div class="l-1">项目</div>
              <div class="l-2">编号</div>
              <div class="l-3">运动员</div>
              <div class="l-4">成绩(评分)</div>
            </div>
            <div
              class="record-item"
              v-for="(i, j) in item.playerList"
              :key="j"
              :style="{ backgroundColor: j % 2 == 0 ? '#F3F5F7' : '' }"
            >
              <div class="l-1">{{ i.combatName }}</div>
              <div class="l-2">{{ i.playerNum }}</div>
              <div class="l-3">
                <img :src="i.playerHead" alt="" />
                <div>
                  <div>{{ i.playerName }}</div>
                  <div>{{ i.agencyName }}</div>
                </div>
              </div>
              <div class="l-4" v-if="i.computeScore || i.examScore">
                {{ i.computeScore ? i.computeScore : '-' }}({{ i.examScore ? i.examScore : '-' }})
              </div>
              <div class="l-4" v-else>-</div>
            </div>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      matchId: this.$route.query.matchId,
      programId: Number(this.$route.query.programId),
      keywords: '',
      sexList: [],
      matchExamDateList: [],
      matchCombatList: [],
      sexList: [],
      examTypeList: [],
      dateIndex: -1, // 初始化的索引
      projectIndex: -1,
      sexIndex: -1,
      examTypeIndex: -1,
      dataList: [], // 列表数据
      customStyle: 'background-color:#31383F;color:#fff;border: 0;overflow: hidden;',
    }
  },
  components: {},
  mounted() {
    this.getmatchExamDate()
  },
  methods: {
    async search() {
      this.dateIndex = -1
      this.projectIndex = -1
      this.sexIndex = -1
      this.examTypeIndex = -1
      console.log(111, '搜索', this.keywords)
      if (this.keywords) {
        let data = {
          matchId: this.matchId,
          matchDate: null,
          age: null,
          sex: null,
          examTypeId: null,
          keywords: this.keywords,
        }
        try {
          let res = await this.$api.match.matchEventData(data)

          if (res.status == 0) {
            this.dataList = res.data
          }
        } catch (error) {
          console.log('error', error)
        }
      }
    },
    handleDateTime(item, index) {
      this.dateIndex = index
      console.log(item, index)
      this.keywords = ''
    },
    handleProject(item, index) {
      this.projectIndex = index
      console.log(item, index)
    },
    handleSex(item, index) {
      this.sexIndex = index
      console.log(item, index)
    },
    handleExam(item, index) {
      this.examTypeIndex = index
      console.log(item, index)
      this.getmatchEventData(this.examTypeList[index])
    },
    //获取数据方法
    async getmatchEventData(item) {
      let data = {
        matchId: this.matchId,
        matchDate: this.matchExamDateList[this.dateIndex].matchTime,
        age: item.age,
        sex: item.sex,
        examTypeId: item.examTypeId,
        keywords: null,
      }
      try {
        let res = await this.$api.match.matchEventData(data)

        if (res.status == 0) {
          this.dataList = res.data
        }
      } catch (error) {
        console.log('error', error)
      }
    },

    //获取体能时间项目
    async getmatchExamDate() {
      try {
        let res = await this.$api.match.matchExamDate(this.matchId)
        console.log('matchExamDateList', res.data)

        if (res.status == 0) {
          this.matchExamDateList = res.data
        }
      } catch (error) {
        console.log('error', error)
      }
    },
  },
  watch: {
    dateIndex(newIndex) {
      if (newIndex > -1) {
        this.matchCombatList = this.matchExamDateList[newIndex].matchCombatList
      }
      this.projectIndex = -1
      this.sexIndex = -1
      this.examTypeIndex = -1
      this.sexList = []
      this.examTypeList = []
      this.dataList = []
    },
    projectIndex(newIndex) {
      if (newIndex > -1) {
        this.sexList = this.matchExamDateList[this.dateIndex].matchCombatList[newIndex].sexList
      }
      this.sexIndex = -1
      this.dataList = []
      this.examTypeList = []
    },
    sexIndex(newIndex) {
      if (newIndex > -1) {
        this.examTypeList = this.matchExamDateList[this.dateIndex].matchCombatList[this.projectIndex].sexList[
          newIndex
        ].examTypeList
      }
      this.examTypeIndex = -1
      this.dataList = []
      console.log('性别index', this.dateIndex, this.projectIndex, this.sexIndex, this.examTypeIndex)
    },
  },
}
</script>

<style scoped lang="scss">
.result-detail {
  width: 1200px;
  margin: 0 auto;
  .result-filter-list {
    width: 100%;
    .search {
      width: 100%;
      height: 68px;
      box-sizing: border-box;
      padding: 10px 0;
      position: relative;
      .search-btn {
        position: absolute;
        right: -20px;
        top: 50%;
        transform: translateY(-50%);
        width: 100px;
        height: 42px;
        color: #fff;
        background-color: #bd0600;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0 10px 10rpx 0;
        cursor: pointer;
      }
    }
    .scro-list {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-items: center;
      gap: 10px;
      margin-bottom: 10px;
      .scro-item {
        width: 110px;
        height: 36px;
        background-color: #f3f5f7;
        color: #333;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .sco-active {
        background-color: #bd0600;
        color: #fff;
        font-weight: bold;
      }
    }
  }
  .collapse {
    width: 100%;
    padding-bottom: 30px;
    box-sizing: border-box;
    .collapse-reduce {
      width: 18px;
      height: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      background-color: #31383f;
      border: 2px solid #fff;
    }
    .collapse-add {
      width: 18px;
      height: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      background-color: #fff;
      border: 2px solid #31383f;
    }
    .match-title {
      background-color: #fff;
      border-bottom: 2px solid #31383f;
      color: #31383f;
      height: 56px;
      padding-left: 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 80px;
      box-sizing: border-box;
      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-weight: bold;
        font-size: 18px;
      }
    }
    .record {
      width: 100%;
      box-sizing: border-box;
      background-color: #fff;
      .record-item {
        width: 100%;
        height: 72px;
        font-size: 16px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 30px;
        box-sizing: border-box;
        .l-1 {
          width: 10%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .l-2 {
          width: 15%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .l-3 {
          width: 60%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          img {
            width: 38px;
            height: 50px;
            margin-right: 10px;
            object-fit: cover;
            object-position: center;
          }
        }
        .l-4 {
          width: 15%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .record-title {
        font-size: 18px;
        height: 56px;
        font-weight: bold;
        border-bottom: 2px solid #31383f;
      }
    }
  }
}
/deep/ .ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header {
  padding: 0 !important;
}
/deep/ .ant-collapse-content > .ant-collapse-content-box {
  padding: 0 !important;
}
/deep/ .ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  width: 18px;
  height: 18px;
  background-color: #31383f;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/PhysicalFitness/components/ResultDetail.vue